import './index.css';
import React from 'react';
interface Props {
  children?: any;
  className?: string;
  style?: React.CSSProperties | undefined;
}
const FlatListWrapper = ({ style, className = '', children }: Props) => {
  return (
    <ul style={style} className={`flat-list-wrapper ${className}`}>
      {children}
    </ul>
  );
};
export default React.memo(FlatListWrapper);
